import { useEffect } from "react";

const DEFAULTS = {
  siteName: "Seven Pillars of Life Therapy",
  siteUrl: "https://www.7pillarsoflife.com",
  ogImage:
    "https://images.unsplash.com/photo-1754037783933-c25ff9f68f87?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  twitter: "@7pillarsoflifetherapy",
};

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.id = id;
    el.type = "application/ld+json";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

/**
 * SEO — sets per-page <title>, meta description, canonical URL,
 * OpenGraph + Twitter card meta, and optional JSON-LD structured data.
 *
 * Usage: <SEO title="..." description="..." path="/services" image="..." />
 */
export default function SEO({
  title,
  description,
  path = "",
  image,
  type = "website",
  jsonLd,
}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | ${DEFAULTS.siteName}`
      : DEFAULTS.siteName;
    const url = `${DEFAULTS.siteUrl}${path}`;
    const ogImage = image || DEFAULTS.ogImage;

    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:site", DEFAULTS.twitter);
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);

    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:site_name", DEFAULTS.siteName);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("property", "og:image:width", "1200");
    upsertMeta("property", "og:image:height", "800");

    upsertLink("canonical", url);

    if (jsonLd) {
      upsertJsonLd("page-jsonld", jsonLd);
    }
  }, [title, description, path, image, type, jsonLd]);

  return null;
}
